import React from "react";
import "./nav.css";
import { AiOutlineHome } from "react-icons/ai";
import { AiOutlineUser } from "react-icons/ai";
import { GoBook } from "react-icons/go";
import { RiServiceLine } from "react-icons/ri";
import { BiMessageRoundedDetail } from "react-icons/bi";
import { useState } from "react";

const Nav = () => {
  const [active, setActive] = useState("#");
  const scrollingUpdate = () => {
    console.log("You should definitely hire me :)");
  };

  window.onscroll = scrollingUpdate;

  return (
    <nav>
      <a
        onClick={(e) => {
          setActive("#");
        }}
        className={active === "#" ? "active" : ""}
        href="#"
      >
        <AiOutlineHome />
      </a>
      <a
        href="#about"
        onClick={(e) => {
          setActive("about");
        }}
        className={active === "about" ? "active" : ""}
      >
        <AiOutlineUser />
      </a>
      <a
        href="#experience"
        onClick={(e) => {
          setActive("experience");
        }}
        className={active === "experience" ? "active" : ""}
      >
        <GoBook />
      </a>
      <a
        href="#services"
        onClick={(e) => {
          setActive("services");
        }}
        className={active === "services" ? "active" : ""}
      >
        <RiServiceLine />
      </a>
      <a
        href="#contact"
        onClick={(e) => {
          setActive("contact");
        }}
        className={active === "contact" ? "active" : ""}
      >
        <BiMessageRoundedDetail />
      </a>
    </nav>
  );
};

export default Nav;
